module.exports = "https://static.wmbcdn.com/uniweb/images/7a1d86761b1c07e8431a7ededf01438e.svg";